/**
 * PDP 배송 표기 — 선택 수량을 MCF 메타필드 재고와 비교해 배송 티어를 맞춘다.
 *
 * 3개 담으려는데 미국 창고에 2개뿐이면 주문 전체가 한국에서 나간다.
 * SSR 은 수량 1 기준으로만 그리므로(snippets/us-shipping-pdp.liquid) 나머지는 여기서 한다.
 *
 * 🔴 판정 규칙의 SSOT 는 snippets/us-shipping-tier.liquid 다.
 *    MCF 충족 → Express, MCF 부족 → Standard 순서를 유지한다.
 *
 * 🔴 상태는 전부 .mcf-note 에 붙어 있다. product-info.js 는 래퍼(.mcf-pdp)의 innerHTML 만
 *    갈아끼우므로, variant 를 바꾸면 이 노드가 통째로 새로 온다.
 */
(() => {
  // PDP 와 퀵뷰 템플릿이 둘 다 불러온다 — 리스너는 한 번만
  if (window.__mcfPdpQuantity) return;
  window.__mcfPdpQuantity = true;

  const NOTE = '.mcf-note[data-mcf-stock]';

  const setText = (root, selector, value) => {
    const node = root?.querySelector(selector);
    if (node && value != null) node.textContent = value;
  };

  const apply = (note, tier) => {
    const wrapper = note.closest('.mcf-pdp');
    wrapper?.classList.remove('mcf-pdp--soldout');
    if (note.dataset.mcfAppliedTier === tier) return;

    const badge = wrapper?.querySelector('.mcf-badge');
    // 두 티어 문구가 다 data 속성으로 와 있다 (us-shipping-pdp.liquid)
    const key = tier === 'express' ? 'Express' : 'Standard';
    const copy = note.dataset;

    setText(badge, '.mcf-badge__label', copy[`mcf${key}Label`]);
    setText(note, '.mcf-note__lead', copy[`mcf${key}Lead`]);
    setText(note, '.mcf-note__detail-text', copy[`mcf${key}Detail`]);

    const from = tier === 'express' ? 'standard' : 'express';
    badge?.classList.replace(`mcf-badge--${from}`, `mcf-badge--${tier}`);
    note.classList.replace(`mcf-note--${from}`, `mcf-note--${tier}`);
    note.dataset.mcfAppliedTier = tier;
  };

  /** 자기 섹션의 선택 수량 (없으면 1) */
  const wantedQty = (node) => {
    const section = node.closest('.shopify-section') || document;
    const quantity = parseInt(section.querySelector('.quantity__input[name="quantity"]')?.value, 10);
    return quantity > 0 ? quantity : 1;
  };

  /** 안내문 하나를 자기 섹션의 수량에 맞춘다 (PDP 한 화면에 PC·MO 인스턴스가 각각 있다) */
  const syncNote = (note) => {
    const mcfStock = parseInt(note.dataset.mcfStock, 10);
    if (!Number.isFinite(mcfStock)) return;
    const tier = mcfStock >= wantedQty(note) ? 'express' : 'standard';
    apply(note, tier);
  };

  /** 재고 표시 박스 (snippets/us-stock-pdp.liquid) — 행별 재고 >= 수량 이면 Available, 미국 행이 티어를 정한다 */
  const syncStock = (box) => {
    const wanted = wantedQty(box);
    box.querySelectorAll('[data-mcf-row-stock]').forEach((row) => {
      const ok = parseInt(row.dataset.mcfRowStock, 10) >= wanted;
      row.classList.toggle('is-available', ok);
      if (row.dataset.mcfRow === 'us') {
        box.classList.toggle('mcf-stock--express', ok);
        box.classList.toggle('mcf-stock--standard', !ok);
      }
    });
  };

  const syncAll = () => {
    document.querySelectorAll(NOTE).forEach(syncNote);
    document.querySelectorAll('.mcf-stock').forEach(syncStock);
  };

  // +/- 버튼은 change, 직접 타이핑은 input 으로 들어온다
  const onQuantity = (event) => {
    if (event.target.matches?.('.quantity__input[name="quantity"]')) syncAll();
  };
  document.addEventListener('change', onQuantity);
  document.addEventListener('input', onQuantity);

  // variant 변경은 이벤트를 안 쏘고 innerHTML 만 갈아끼운다 → 교체를 직접 감시한다.
  // subtree:false 라 apply() 의 textContent 변경으로는 다시 깨지 않는다.
  const watch = (wrapper) => {
    if (wrapper.__mcfWatched) return;
    wrapper.__mcfWatched = true;
    new MutationObserver(syncAll).observe(wrapper, { childList: true });
  };

  // 퀵뷰처럼 나중에 들어온 래퍼는 감시가 안 붙는다 → 테마 variant 변경 이벤트로도 재판정
  window.FoxTheme?.pubsub?.subscribe(window.FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, syncAll);

  const init = () => {
    document.querySelectorAll('.mcf-pdp, .mcf-stock-wrap').forEach(watch);
    syncAll();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
